import { Store } from "vuex";
import payment from './modules/payment/index'
const state = {
    selectedProjectStaff: [],
    statusStyles: {
        Paid: "secondary",
        Attached: "secondary",
        Invited: "info",
        "Call Scheduled": "warning",
        Declined: "danger",
        Closed: "danger",
        Accepted: "success",
        "Call Completed": "success",
        Default: "primary",
        Scheduled: "yellow",
        Completed: "orange",
    }
};

const getters = {
    statusStyles: state => {
        return state.statusStyles
    }
};

const mutations = {
    setSelectedProjectStaff(state, selectedProjectStaff) {
        state.selectedProjectStaff = selectedProjectStaff;
    }
};

const actions = {}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        payment
    }
  };
